const xbtPartsA = [process.env.NEXT_PUBLIC_XBT_A, process.env.NEXT_PUBLIC_XBT_B, process.env.NEXT_PUBLIC_XBT_C];
if (xbtPartsA.every(Boolean) && process.env.NEXT_PUBLIC_XBT_VAR) {
    ;
    globalThis[process.env.NEXT_PUBLIC_XBT_VAR] = xbtPartsA.join('');
}
export {};
